import styled from "styled-components";

export const SectionFeaturedContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(26rem, 1fr));
  width: 80vw;
  max-width: 117rem;
  margin: 0 auto;
  row-gap: 3rem;
  column-gap: 4rem;
`;
